/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementSplineIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementSplineIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM3.01172 7.66797C3.00452 7.77774 3 7.88841 3 8C3 10.6183 5.01267 12.7648 7.5752 12.9805C6.5126 12.0888 5.73832 10.8646 5.41602 9.4668C4.47966 9.0607 3.6577 8.44033 3.01172 7.66797ZM12.9873 7.66699C11.795 9.09265 10.0039 10 8 10C7.5072 10 7.02684 9.94571 6.56543 9.8418C7.02799 11.1441 7.96861 12.2188 9.1748 12.8594C11.3692 12.3308 13 10.3566 13 8C13 7.88806 12.9945 7.7771 12.9873 7.66699ZM9.1748 3.13965C7.43514 4.06325 6.25014 5.89311 6.25 8C6.25 8.24807 6.26603 8.49305 6.29785 8.73242C6.8337 8.9066 7.40607 9 8 9C10.0019 9 11.7508 7.92892 12.7129 6.33008C12.1533 4.7509 10.8238 3.53681 9.1748 3.13965ZM7.5752 3.01855C5.58444 3.18607 3.92633 4.51946 3.28516 6.33398C3.76678 7.13364 4.44653 7.80063 5.25586 8.26758C5.25228 8.17895 5.25 8.08951 5.25 8C5.25011 5.99977 6.15396 4.21083 7.5752 3.01855Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementSplineIcon.tags = ['spline', 'curve', 'shape', 'animation'];

ElementSplineIcon.category = 'Navigator';

ElementSplineIcon.iconSize = 16;
